export default {
  PROJECT: 'select_project',
  DETAILS: 'provide_details',
  CONTACT_INFO: 'contact_info',
  SUMMARY: 'summary',
};
